import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Faq } from "../../../../core/models/faq.model";
import { FaqService } from "../../../../core/services/faq.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { ConfirmActionModalComponent } from "../../../../shared/confirm-action-modal/confirm-action-modal.component";
import { TrialDetail } from "../../../../core/models/trial-detail.model";
import { Cultures } from "../../../../core/constants/cultures";
import { FaqFormComponent } from "./faq-form/faq-form.component";

@Component({
  selector: 'app-trial-faqs',
  templateUrl: './trial-faqs.component.html',
  styleUrl: './trial-faqs.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class TrialFaqsComponent implements OnInit {
  @ViewChild('faqModal') supportModal: FaqFormComponent;
  @ViewChild('confirmModal') confirmModal: ConfirmActionModalComponent;

  @Input() trial: TrialDetail;

  @Output() hasChanged = new EventEmitter<boolean>(false);

  faqs: Faq[] = [];
  dataLoaded = false;

  availableCultures: { value: string, text: string }[] = [];
  supportInfoFilteredCultures: { value: string, text: string }[] = [];
  hasChanges: boolean = false;

  constructor(private _faqService: FaqService, private _alertService: AlertService) {
    Cultures.all().forEach(culture => {
      this.availableCultures.push({ value: culture.culture, text: culture.name });
    });
    this.supportInfoFilteredCultures = this.availableCultures;
  }

  ngOnInit() {
    this.dataLoaded = false;
    this._faqService.list(this.trial.id).subscribe({
      next: links => {
        this.faqs = links;
        this.dataLoaded = true;
      },
      error: err => {
        this._alertService.showErrorResponse(err);
        this.dataLoaded = true;
      }
    });
  }

  splitCountries(countries: string): string[] {
    return countries.split(',');
  }

  onRemoveConfirmed(faqId: string) {
    this._faqService.remove(faqId).subscribe({
      next: faqs => {
        this.onAddOrUpdate(faqs);
        this.hasChanges = true;
        this.hasChanged.emit(this.hasChanges);
        this._alertService.showSuccessAlert("FAQ link has been removed successfully.");
      },
      error: err => {
        this._alertService.showErrorResponse(err);
      }
    });
  }

  onRemove(faq: Faq) {
    this.confirmModal.showConfirmation(faq.id);
  }

  drop(event: CdkDragDrop<Faq[]>) {
    moveItemInArray(this.faqs, event.previousIndex, event.currentIndex);
    this.hasChanges = true;
    this.hasChanged.emit(this.hasChanges);

    // Update the order on the backend
    this._faqService.setOrder(this.trial.id, this.faqs.map(r => r.id)).subscribe({
      next: (faqs) => {
        this.faqs = faqs;
      },
      error: err => {
        // Revert the order on error
        moveItemInArray(this.faqs, event.currentIndex, event.previousIndex);
        this.hasChanges = false;
        this.hasChanged.emit(this.hasChanges);
        this._alertService.showErrorResponse(err);
      }
    });
  }

  onAddOrUpdate(faqs: Faq[]) {
    this.faqs = faqs;

    this._faqService.setOrder(this.trial.id, this.faqs.map(r => r.id)).subscribe({
      next: (faqs) => {
        this.faqs = faqs;
      }});
  }

  protected readonly Faq = Faq;
}
